import type { AssetType } from '@keetcheck/shared';

/** Display label and icon for each asset type (order = picker order). */
export const ASSET_TYPE_OPTIONS: { key: AssetType; label: string; icon: string }[] = [
  { key: 'truck',     label: 'Truck',     icon: 'truck'     },
  { key: '4x4',       label: '4x4',       icon: '4x4'       },
  { key: 'ute',       label: 'Ute',       icon: 'ute'       },
  { key: 'van',       label: 'Van',       icon: 'van'       },
  { key: 'car',       label: 'Car',       icon: 'car'       },
  { key: 'trailer',   label: 'Trailer',   icon: 'trailer'   },
  { key: 'boat',      label: 'Boat',      icon: 'boat'      },
  { key: 'shed',      label: 'Shed',      icon: 'shed'      },
  { key: 'container', label: 'Container', icon: 'container' },
  { key: 'other',     label: 'Other',     icon: 'package'   },
];

const byKey = new Map(ASSET_TYPE_OPTIONS.map((o) => [o.key, o]));

export const assetTypeLabel = (t: string | null | undefined) => byKey.get(t as AssetType)?.label ?? 'Other';
export const assetTypeIcon  = (t: string | null | undefined) => byKey.get(t as AssetType)?.icon ?? 'package';
